import React from "react";

/**
 * Ilustração decorativa (SVG) usada no lugar de uma foto na seção
 * "Mais do que Contabilidade" (Home / About). Compõe um "documento"
 * organizado, um selo de conformidade e um gráfico de crescimento —
 * elementos que remetem diretamente ao trabalho de uma contabilidade,
 * usando a mesma paleta de azul + dourado do restante do site.
 *
 * É puramente decorativa (aria-hidden), então não substitui nenhum
 * conteúdo textual da página.
 */
export default function AboutIllustration() {
  return (
    <svg
      viewBox="0 0 400 380"
      className="about-illustration"
      role="img"
      aria-hidden="true"
      xmlns="http://www.w3.org/2000/svg"
    >
      <defs>
        <linearGradient id="aiBg" x1="0%" y1="0%" x2="100%" y2="100%">
          <stop offset="0%" stopColor="#050c22" />
          <stop offset="45%" stopColor="#0c1f45" />
          <stop offset="100%" stopColor="#2a4d94" />
        </linearGradient>
        <linearGradient id="aiGold" x1="0%" y1="0%" x2="100%" y2="100%">
          <stop offset="0%" stopColor="#c9a24b" />
          <stop offset="100%" stopColor="#e6c274" />
        </linearGradient>
        <radialGradient id="aiGlow" cx="20%" cy="10%" r="75%">
          <stop offset="0%" stopColor="#ffffff" stopOpacity="0.22" />
          <stop offset="100%" stopColor="#ffffff" stopOpacity="0" />
        </radialGradient>
        <pattern id="aiDots" width="22" height="22" patternUnits="userSpaceOnUse">
          <circle cx="2" cy="2" r="1.4" fill="#c9a24b" opacity="0.35" />
        </pattern>
        <clipPath id="aiPanel">
          <rect x="0" y="0" width="400" height="380" rx="32" />
        </clipPath>
      </defs>

      <g clipPath="url(#aiPanel)">
        <rect x="0" y="0" width="400" height="380" fill="url(#aiBg)" />
        <rect x="0" y="0" width="400" height="380" fill="url(#aiGlow)" />
        <rect x="0" y="0" width="400" height="380" fill="url(#aiDots)" />

        <circle
          className="about-illustration__float-slow"
          cx="368"
          cy="46"
          r="70"
          fill="none"
          stroke="#ffffff"
          strokeOpacity="0.14"
          strokeWidth="2"
        />
        <circle
          className="about-illustration__float-fast"
          cx="26"
          cy="340"
          r="52"
          fill="none"
          stroke="#e6c274"
          strokeOpacity="0.25"
          strokeWidth="2"
        />
      </g>

      {/* "Documento" organizado, representando o trabalho contábil */}
      <g className="about-illustration__card">
        <rect x="100" y="66" width="200" height="212" rx="18" fill="#ffffff" />
        <rect x="124" y="94" width="72" height="9" rx="4.5" fill="url(#aiGold)" />
        <rect x="124" y="120" width="152" height="8" rx="4" fill="#e4e8f2" />
        <rect x="124" y="140" width="120" height="8" rx="4" fill="#e4e8f2" />
        <rect x="124" y="160" width="152" height="8" rx="4" fill="#e4e8f2" />
        <rect x="124" y="180" width="96" height="8" rx="4" fill="#e4e8f2" />
        <line x1="124" y1="206" x2="276" y2="206" stroke="#eef0f4" strokeWidth="2" />
        <rect x="124" y="222" width="16" height="16" rx="4" fill="url(#aiGold)" />
        <rect x="150" y="226" width="90" height="8" rx="4" fill="#e4e8f2" />
      </g>

      {/* Selo de conformidade */}
      <g className="about-illustration__badge">
        <circle cx="298" cy="276" r="34" fill="url(#aiGold)" />
        <path
          d="M283 277 L294 288 L315 263"
          fill="none"
          stroke="#1a1408"
          strokeWidth="6"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>

      {/* Gráfico de crescimento */}
      <g className="about-illustration__chart" transform="translate(46, 250)">
        <rect x="0" y="46" width="14" height="24" rx="4" fill="url(#aiGold)" opacity="0.55" />
        <rect x="20" y="34" width="14" height="36" rx="4" fill="url(#aiGold)" opacity="0.75" />
        <rect x="40" y="18" width="14" height="52" rx="4" fill="url(#aiGold)" opacity="0.9" />
        <rect x="60" y="2" width="14" height="68" rx="4" fill="url(#aiGold)" />
        <path
          d="M4 44 L27 32 L47 16 L67 0"
          fill="none"
          stroke="#ffffff"
          strokeOpacity="0.55"
          strokeWidth="2"
          strokeDasharray="1 6"
          strokeLinecap="round"
        />
      </g>

      <circle className="about-illustration__dot about-illustration__float-fast" cx="340" cy="150" r="5" fill="#e6c274" />
      <circle className="about-illustration__dot about-illustration__float-slow" cx="70" cy="52" r="4" fill="#ffffff" fillOpacity="0.5" />
    </svg>
  );
}
